export const queueTaskInBackground =
  (window.requestIdleCallback as typeof window.requestIdleCallback | undefined) ||
  window.setTimeout;
